import { Component, OnInit, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { MainStore } from 'src/app/common/main.store';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { Department } from 'src/app/features/customer/customer.model';
import { DepartmentService } from 'src/app/services/department.service';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from "src/environments/environment";
import { CtrlClickDirective } from '../../directives/ctrl-click.directive';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-top-menu',
    templateUrl: './top-menu.component.html',
    styleUrl: './top-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, CtrlClickDirective, FormsModule]
})
export class TopMenuComponent implements OnInit {

  departments: Department[] = [];
  selectedDepartment: Department = {} as Department;
  departmentDropdown: { value: string, text: string }[] = [];
  selectedDropdown: string = '';
  enviromentInfo: string;
  environment = environment.environment;

  // URLs where department selector should be hidden
  private readonly HIDDEN_ROUTES = [
    '/admin-dashboard',
    '/customer-administration',
    '/db-templates',
    '/translations',
    '/synchronization/',
  ];

  // Reactive URL tracking using writable signal
  private currentUrl = signal(this.router.url);

  // Computed signal to determine if department selector should be shown
  showDepartmentSelector = computed(() => {
    const url = this.currentUrl();
    const shouldShow = !this.HIDDEN_ROUTES.some(route => url.startsWith(route));
    return shouldShow;
  });

  constructor(
    public authService: AuthService,
    public departmentService: DepartmentService,
    public store: MainStore,
    private userService: UserService,
    public commonService: CommonService,
    public router: Router,
    private toasterSerivce: ToastrService
  ) {
    this.enviromentInfo = 'Miljø: ' + environment.environment;

    // Subscribe to router events and update signal
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.set(event.url);
      }
    });
  }

  async ngOnInit(): Promise<void> {
    if (this.store.currentUser.get().isAdmin) {
      this.departments = await this.departmentService.getDepartments();
    }
    else {
      this.departments = await this.departmentService.getAvailableDepartments();
    }
    this.store.departmentList.set(this.departments);

    this.selectedDepartment = this.departmentService.getDepartment();
    this.departmentDropdown = this.departments.map(x => { return { value: x.id, text: x.name + ' [' + x.code + ']' } });
    this.departmentDropdown.unshift({ value: this.commonService.guidEmpty(), text: 'Vælg afdeling' });

    if (this.selectedDepartment == undefined || this.selectedDepartment.id == undefined || this.selectedDepartment.id == '' || this.selectedDepartment.id == this.commonService.guidEmpty()) {
      this.selectedDepartment = this.store.departmentList.get()[0];
    }

    const foundDepartment = this.departments.find(x => x.id == this.selectedDepartment.id);
    if (foundDepartment == undefined) {
      this.selectedDepartment = this.store.departmentList.get()[0];
    }
    else {
      this.selectedDepartment = foundDepartment;
    }
    this.departmentService.setSelectedDepartment(this.selectedDepartment);
    this.selectedDropdown = this.selectedDepartment.id;

    this.commonService.DepartmentChanged.subscribe(async (department: Department) => {
      this.selectedDepartment = department;
      this.selectedDropdown = department.id;
    });
  }

  onSetDepartmentValue($event: any) {
    if ($event == this.commonService.guidEmpty()) return;
    this.selectedDepartment = this.store.departmentList.get().find(x => x.id == $event) || {} as Department;
    this.departmentService.setSelectedDepartment(this.selectedDepartment);
  }

  setDepartmentDropdownText(optionDepartment: Department): string {
    if (optionDepartment.code == '' || optionDepartment.code == undefined || optionDepartment.code == this.commonService.guidEmpty()) {
      return optionDepartment.name
    }
    else {
      return optionDepartment.name + ' [' + optionDepartment.code + ']';
    }
  }

  get getInitials() {
    const fuldenavnArr = this.store.currentUser.get().name.split(' ');
    if (fuldenavnArr != undefined && fuldenavnArr.length > 1) {
      const initials = (fuldenavnArr.shift()?.charAt(0) || '') + (fuldenavnArr.pop()?.charAt(0) || '');
      return initials.toUpperCase();
    }
    else {
      return "UN";
    }
  }

  home() {
    this.router.navigate(['home']);
  }

  async refreshUser() {
    await this.userService.getUserInfo();
  }

  showVersion(event: any) {
    event.preventDefault();
    this.toasterSerivce.info('Version: ' + environment.version + ' - ' + environment.environment);
  }

  logout() {
    this.store.currentUser.clear();
    this.authService.logout();
  }
}
